import React, { Component } from "react";
import { observer } from "mobx-react";
import TabName from "./TabName.js";
import { DnDCard } from "app/common/components/DnD/Card";
import { useContext } from "react";
import { PackStoreContext } from "app/Pack/PackStore.js";

function TabNames(props) {
  const store = useContext(PackStoreContext);

  return props.sheets.map((sheet, index) => (
    <DnDCard
      index={index}
      key={sheet.id}
      isHorizontal
      moveCard={store.reorderSheet}
      id={sheet.id}
      onDropped={store.saveSheetOrder}
    >
      <TabName
        sheet={sheet}
        index={index}
        isSelected={props.selectedSheet === sheet}
        changeSheet={props.changeSheet}
        renameSheet={props.renameSheet}
        deleteSheet={props.deleteSheet}
        openLogSheet={props.openLogSheet}
        duplicateSheet={props.duplicateSheet}
        isEditing={store.lastCreatedSheetId === sheet.id}
        store={store}
      />
    </DnDCard>
  ));
}

export default observer(TabNames);
